import get from 'lodash-es/get';
import isArray from 'lodash-es/isArray';
import isEmpty from 'lodash-es/isEmpty';
import { ENV_DEV } from '../../../constants';
import ZTrackingClient from '../../../jumbo/ZTrackingClient';
import { signOut } from '../../../actions/auth';

export const METHOD_POST = 'POST';
export const METHOD_GET = 'GET';
export const METHOD_PUT = 'PUT';

// check for array to add multiple value corresponding the single key
function concatQueryString(key, value) {
  if (isArray(value)) {
    return value.map(item => `${key}[]=${item}`).join('&');
  }
  return `${key}=${value}`;
}

export function getPostRequestBody(data) {
  const formData = new FormData();
  const convertObjectToKeys = (prependKey, obj) => {
    Object.keys(obj).forEach(key => {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        const nextPrependKey =
          prependKey === '' ? key : `${prependKey}[${key}]`;
        convertObjectToKeys(nextPrependKey, obj[key]);
      } else {
        const newKey = prependKey === '' ? key : `${prependKey}[${key}]`;
        formData.append(newKey, obj[key]);
      }
    });
  };
  convertObjectToKeys('', data);

  return formData;
}

export function formatQueryParams(params) {
  return Object.keys(params)
    .map(k => concatQueryString(k, params[k]))
    .join('&');
}

export const attachQueryParamsInUrl = (url, options = {}) => {
  if (isEmpty(options)) {
    return url;
  }
  return (
    url + (url.indexOf('?') === -1 ? '?' : '&') + formatQueryParams(options)
  );
};

const getForceserver = () => {
  if (
    process.env.NODE_ENV === ENV_DEV &&
    window.localStorage.getItem('forceserver') !== null
  ) {
    return {
      forceserver: JSON.parse(window.localStorage.getItem('forceserver')),
    };
  }
  return {};
};

export const getCookieValue = name => {
  return `; ${document.cookie}`
    .split(`; ${name}=`)
    .pop()
    .split(';')
    .shift();
};

const configureFetch = (url, options = {}) => {
  let config = {
    ...get(options, 'extra', {}),
    headers: {
      ...(options.headers || {}),
      // 'x-client-id': process.env.REACT_APP_CLIENT_ID,
      // 'x-zomato-app-version': process.env.REACT_APP_APP_VERSION,
      // 'x-zomato-api-key': process.env.REACT_APP_ZOMATO_API_KEY,
      'x-zomato-csrf-token': getCookieValue('__Host-csrft'),
      ...getForceserver(),
    },
    url: attachQueryParamsInUrl(url, get(options, 'params', {})),
    method: options.method || METHOD_GET,
    credentials: 'include',
  };

  // attach body only when it's not a get request
  if (get(options, 'method', METHOD_GET).toUpperCase() !== METHOD_GET) {
    config = {
      ...config,
      body: get(options, 'body', {}),
    };
  }

  return config;
};

const checkStatus = async response => {
  if (response.redirected) {
    window.location.href = response.url;
  }

  if (response.status === 401) {
    if (window.zoauth !== undefined) {
      console.log('Signing out...');
      signOut()
        .then(res => {
          console.log(res);
          console.log('Logging out user...');
          // REDIRECT TO HOME ROUTE
          window.location.reload();
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  if (response.ok) {
    return response;
  }

  const error = new Error(`HTTP ${response.status}: ${response.statusText}`);
  error.response = response;
  throw error;
};

const trackPerformance = (response, config, startTime) => {
  const urlObj = new URL(response.url);
  const endTime = performance.now();
  ZTrackingClient.recordPageLaunch({
    request_domain: `${urlObj.protocol}//${urlObj.hostname}${
      urlObj.port ? `:${urlObj.port}` : ''
    }`,
    request_path: `${urlObj.pathname}${urlObj.search}`,
    request_method: config.method,
    status_code: response.status,
    response_time: endTime - startTime,
    message: response.statusText,
  });
};

const zfetch = async (url, options = {}) => {
  const config = configureFetch(url, options);
  const startTime = performance.now();
  const response = await fetch(config.url, config);
  trackPerformance(response, config, startTime);
  return checkStatus(response);
};

export const zPost = async ({ url, body }) => {
  try {
    const response = await zfetch(url, {
      body: JSON.stringify(body),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return await response.json();
  } catch (error) {
    console.error('Error in zPost:', error);
    throw error;
  }
};

export default zfetch;
